/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Book_50_SelectedInputs */

const fr_book_50_selected = /** @type {(inputs: Book_50_SelectedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`/ 50 sélectionnées`)
};

const de_book_50_selected = /** @type {(inputs: Book_50_SelectedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`/ 50 ausgewählt`)
};

const ja_book_50_selected = /** @type {(inputs: Book_50_SelectedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`/ 50枚 選択済み`)
};

const zh_book_50_selected = /** @type {(inputs: Book_50_SelectedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`/ 50 已选`)
};

const ar_book_50_selected = /** @type {(inputs: Book_50_SelectedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`/ 50 محددة`)
};

const id_book_50_selected = /** @type {(inputs: Book_50_SelectedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`/ 50 terpilih`)
};

const it_book_50_selected = /** @type {(inputs: Book_50_SelectedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`/ 50 selezionate`)
};

const ru_book_50_selected = /** @type {(inputs: Book_50_SelectedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`/ 50 выбрано`)
};

const pt_book_50_selected = /** @type {(inputs: Book_50_SelectedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`/ 50 selecionadas`)
};

const ko_book_50_selected = /** @type {(inputs: Book_50_SelectedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`/ 50개 선택됨`)
};

/** @type {(inputs: Book_50_SelectedInputs) => LocalizedString} */
const en_book_50_selected = () => /** @type {LocalizedString} */ ('book_50_selected')

/** @type {(inputs: Book_50_SelectedInputs) => LocalizedString} */
const es_book_50_selected = en_book_50_selected;

/**

* @param {Book_50_SelectedInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const book_50_selected = /** @type {((inputs?: Book_50_SelectedInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Book_50_SelectedInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_book_50_selected(inputs)
	if (locale === "es") return es_book_50_selected(inputs)
	if (locale === "fr") return fr_book_50_selected(inputs)
	if (locale === "de") return de_book_50_selected(inputs)
	if (locale === "ja") return ja_book_50_selected(inputs)
	if (locale === "zh") return zh_book_50_selected(inputs)
	if (locale === "ar") return ar_book_50_selected(inputs)
	if (locale === "id") return id_book_50_selected(inputs)
	if (locale === "it") return it_book_50_selected(inputs)
	if (locale === "ru") return ru_book_50_selected(inputs)
	if (locale === "pt") return pt_book_50_selected(inputs)
	return ko_book_50_selected(inputs)
});